<template>
   <div class="page">
     <page-header ></page-header>
     
     <div class="banners" :style="banner.bg" v-if="banner">
       <div class="main">
         <div class="game-desc">
            <div class="name">
              <div class="title">{{banner.name}}</div>	
              <div class="subtit">{{banner.subtitle}}</div>
            </div>
            <div class="txt">{{banner.txt}}</div>
            <div class="download">下载游戏：</div>
            <div class="ul">
              <div class="li" @click="toDown"><img src="@/assets/images/img/iphone.png" alt=""></div>
              <div class="li" @click="toDown"><img src="@/assets/images/img/Android.png" alt=""></div>
              <div class="li" @click="toDown"><img src="@/assets/images/img/ipad.png" alt=""></div>
              <div class="li code"><img :src="banner.code" alt=""></div>
            </div>
          </div>

       </div>
     </div>

     <div class="c-container">
       <div class="main">
         <div class="li" v-for="(item,index) in list" :key="index">
           <img :src="item" alt="">
         </div>
         
       </div>
     </div>

     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
     lists : [
       {
         type : 1,
         list : [
           require('@/assets/images/ddz-01.jpg'),
           require('@/assets/images/ddz-02.jpg'),
           require('@/assets/images/ddz-03.jpg')
         ],
         banner : {
             bg : {
               backgroundImage : 'url(' + require('@/assets/images/ddz-barnner.jpg') + ')'
             },
             code : require('@/assets/images/xyqp-ewm.png'),
             name : '斗地主',
             subtitle : 'LANDLORDS',
             txt : '精美的游戏画面;特色地方性玩法;趣味的道具表情。',
             down : 'http://apk.xianyigame.com/web-down/index.html'
         }
       },
       {
         type : 2,
         list : [
           require('@/assets/images/pp-01.jpg'),
           require('@/assets/images/pp-02.jpg'),
           require('@/assets/images/pp-03.jpg')
         ],
         banner : {
             bg : {
               backgroundImage : 'url(' + require('@/assets/images/ph-barnner.jpg') + ')'
             },
             code : require('@/assets/images/xyqp-ewm.png'),
             name : '碰碰',
             subtitle : 'TOUCH HU',
             txt : '精美的游戏画面;特色地方性玩法;趣味的道具表情。',
             down : 'http://apk.xianyigame.com/web-down/index.html'
         }
       },
       {
         type : 3,
         list : [
           require('@/assets/images/hz-01.jpg'),
           require('@/assets/images/hz-02.jpg'),
           require('@/assets/images/hz-03.jpg')
         ],
         banner : {
             bg : {
               backgroundImage : 'url(' + require('@/assets/images/hz-barnner.jpg') + ')'
             },
             code : require('@/assets/images/xyqp-ewm.png'),
             name : '红中麻将',
             subtitle : 'RED MAHJONG',
             txt : '精美的游戏画面;特色地方性玩法;趣味的道具表情。',
             down : 'http://apk.xianyigame.com/web-down/index.html'
         }
       },
       {
         type : 4,
         list : [
           require('@/assets/images/zz-01.jpg'),
           require('@/assets/images/zz-02.jpg'),
           require('@/assets/images/zz-03.jpg')
         ],
         banner : {
             bg : {
               backgroundImage : 'url(' + require('@/assets/images/zz-barnner.jpg') + ')'
             },
             code : require('@/assets/images/xyqp-ewm.png'),
             name : '转转麻将',
             subtitle : 'AROUND MAHJONG',
             txt : '精美的游戏画面;特色地方性玩法;趣味的道具表情。',
             down : 'http://apk.xianyigame.com/web-down/index.html'
         }
       },
       {
         type : 5,
         list : [
           require('@/assets/images/xyqp-01.jpg'),
           require('@/assets/images/xyqp-02.jpg'),
           require('@/assets/images/xyqp-03.jpg')
         ],
         banner : {
             bg : {
               backgroundImage : 'url(' + require('@/assets/images/xyqp-barnner.jpg') + ')'
             },
             code : require('@/assets/images/xyqp-ewm.png'),
             name : '闲逸麻将',
             subtitle : 'IDLE CHESS',
             txt : '浓烈的家乡语音和最地道的斗牛玩法,随时随地邀请好友一起组局。',
             down : 'http://apk.xianyigame.com/web-down/index.html'
         }
       },
       {
         type : 6,
         list : [
           require('@/assets/images/pdk-01.jpg'),
           require('@/assets/images/pdk-02.jpg'),
           require('@/assets/images/pdk-03.jpg')
         ],
         banner : {
             bg : {
               backgroundImage : 'url(' + require('@/assets/images/pdk-barnner.jpg') + ')'
             },
             code : require('@/assets/images/xyqp-ewm.png'),
             name : '跑得快',
             subtitle : 'RUN FAST',
             txt : '简洁精美的游戏界面,流畅的对局操作,华丽的棋牌特效。',
             down : 'http://apk.xianyigame.com/web-down/index.html'
         }
       }

     ],
     list : [],
     banner : null,
     type : 0,
    }
  },
  created () {
  },
  mounted () {
    let {type} = this.$route.query;

    this.type = type;
    console.log(type)

    let data = this.lists.filter( x => {
      return x.type == type
    });
    this.list = data[0].list;
    this.banner = data[0].banner;
    console.log(this.banner)
  },
  
  methods: {
    toNews(e){
      console.log(e)
    },
    toGames(e){
      console.log(e)
    },
    toBack(){
      this.$router.back()
    },
    toDown(){
      let d = this.banner.down
      window.open(d);
    }
  }
}
</script>
<style lang="less" scoped>
.main{
  max-width: 512px;
  margin: 0 auto;
  position: relative;
}
.banners{
  height: 210px;
  // background: url(../../assets/images/act-banner.jpg) no-repeat center;
  
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  .containt-div{
      max-width: 512px;
      position: relative;
      height: 300px;
      margin: 0 auto;
      padding-left: 10px;
      box-sizing: border-box;
      color: #fff;
  }

}

.game-desc{
  width: 170px;
  height: 150px;
  position: absolute;
  right: 0;
  top: 50px;
  font-size: 10px;
  color: #fff;
  text-align: center;
  .name{
    margin-bottom: 20px;
  }
  .txt{
    font-size: 7px;
    margin-bottom: 20px;
    text-align: left;
  }
  .subtit{
    font-size: 6px;
  }
  .download{
    text-align: left;
    height: 20px;
    display: flex;
    align-items: center;
    font-size: 8px;
    background: url(../../assets/images/img/download.png)no-repeat left center;
    background-size: auto 15px;
    padding-left: 20px;
    margin-bottom: 10px;
  }
  .ul{
    width: 170px;
    display: flex;
    .li{
      width: 40px;
      height: 40px;
      box-sizing: border-box;
      margin-left: 1px;
      background: rgba(255, 255, 255, .5);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img{
        width: 15px;
        height: auto;
      }
      &:hover{
        background: rgba(255, 255, 255, 1);
      }
      &.code{
        img{
          width: 36px;
          height: 36px;
          opacity: .8;
        }
      }
    }
  }
}

.c-container{
	width: 100%;
	overflow: hidden;
  padding-top: 15px;
  .main{
    img{
      width: 100%;
    }
  }
  
  
}




@media (max-width:800px) {
  .game-desc{
    top: 30px;
  }

  .c-container{
    width: 100%;
    overflow: hidden;
    padding: 15px 5px 0;
    box-sizing: border-box;
    
    
  }


}


</style>
